import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ['form', 'submitButton', 'buttonSpan', 'buttonIconLoading', 'documentSection', 'beneficioSelect'];

  connect() {
    document.body.scrollTop = 0;

    if (this.hasFormTarget) {
      this.formTarget.addEventListener('submit', (e) => {
        e.submitter.disabled = true;
        this.buttonSpanTarget.style.display = 'none';
        this.buttonIconLoadingTarget.style.display = 'block';
      });
    }

    this.configureFieldFocus();

    // Verifica o benefício selecionado ao carregar a página
    if (this.hasBeneficioSelectTarget) {
      this.toggleDocumentSection();
    }
  }

  configureFieldFocus() {
    const fields = this.element.querySelectorAll('.field');

    fields.forEach(field => {
      const input = field.querySelector('.field-input');
      const label = field.querySelector('label');

      if (!input) return;

      if (input.value.trim() !== '') {
        label.classList.add('focus');
      }

      input.addEventListener('focus', () => {
        label.classList.add('focus');
      });

      input.addEventListener('blur', () => {
        if (!input.value.trim()) {
          label.classList.remove('focus');
        }
      });

      input.addEventListener('input', () => {
        if (input.value.trim() !== '') {
          label.classList.add('focus');
        }

        input.addEventListener('focus', () => {
          label.classList.add('focus');
        });

        input.addEventListener('blur', () => {
          if (!input.value.trim()) {
            label.classList.remove('focus');
          }
        });

        input.addEventListener('input', () => {
          if (input.value.trim() !== '') {
            label.classList.add('focus');
          } else {
            label.classList.remove('focus');
          }
        });

        // Detecta preenchimento automático do navegador (autocomplete)
        input.addEventListener('animationstart', (e) => {
          if (e.animationName === 'onAutoFillStart') {
            label.classList.add('focus');
          }
          if (e.animationName === 'onAutoFillCancel' && !input.value.trim()) {
            label.classList.remove('focus');
          }
        });

        // Adiciona uma pequena animação para detectar o preenchimento automático
        input.classList.add('detect-autofill');
      })
    });
  }

  toggleDocumentSection() {
    const selectedBeneficioId = this.beneficioSelectTarget.value;
    const isKidBeneficio = true // this.isKidBeneficio(selectedBeneficioId);

    // Mostra ou esconde a seção de documentos
    if (this.hasDocumentSectionTarget) {
      this.documentSectionTarget.style.display = isKidBeneficio ? "block" : "none";
    }

    this.checkAndShowPcdModal();
  }

  isKidBeneficio(beneficioId) {
    // Verifica se o benefício selecionado é do tipo "kids" com base em um atributo data.
    const selectedOption = this.beneficioSelectTarget.querySelector(`option[value="${beneficioId}"]`);
    return selectedOption && selectedOption.dataset.kids === "true";
  }

  checkAndShowPcdModal() {
    const selectedBeneficioId = this.beneficioSelectTarget.value;
    const selectedOption = this.beneficioSelectTarget.querySelector(`option[value="${selectedBeneficioId}"]`);
    const isPcd = selectedOption && selectedOption.textContent?.trim().includes("PCD");

    if (isPcd) {
      MicroModal.show('modal-aviso-pcd');
    }
  }

}